// @flow
import './TimelineDatapointForm.css';

import * as React from 'react';
import classNames from 'classnames';
import Button from '../common/Button';
import { parsePlaybackTime, toSMPTE, smpteToMillis } from '../util/VideoUtil';
import { KeyFrameMetadataEntry } from '../autogenerated/ZoomBridge';
import VideoController from './VideoController';
import t from '../i18n/I18n';
import { ThemeSetup } from '../themes/ThemeSetup';
import AutoCompleteComponent from '../common/form/advanceSearchComponent/AutoComplateComponent';

const debug = require('../debug/debug')('wc:video:TimelineDatapointForm');
type Props = {
  keyFrameMetadataEntry: KeyFrameMetadataEntry,
  index?: number,
  startTimeInvalid: boolean,
  stopTimeInvalid: boolean,
  onChange: Function,
  onDeleteClick?: Function,
  videoController: VideoController,
  groupName: string
};

type State = {
  label: string,
  startTimeMs: string,
  stopTimeMs: string
};

export default class TimelineDatapointForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const entry = this.props.keyFrameMetadataEntry;
    const mdMapEntries = entry.getMetadataMap().toArray();

    this.state = {
      label: mdMapEntries.length ? mdMapEntries[0].value : '',
      startTimeMs: toSMPTE(
        entry.getStartTime() + props.videoController.videoStartTimecode,
        props.videoController.frameRate
      ),
      stopTimeMs: toSMPTE(
        entry.getEndTime() + props.videoController.videoStartTimecode,
        props.videoController.frameRate
      )
    };
  }

  onChange = (prop: string, value: string) => {
    const { onChange } = this.props;
    this.setState({ [prop]: value }, () => {
      this.onBlur(prop, value);
    });
  };

  onBlur = (prop: string, value: string) => {
    const { onChange } = this.props;
    if (prop === 'label') {
      onChange(prop, value);
    } else {
      const millis =
        smpteToMillis(value, this.props.videoController.frameRate) - this.props.videoController.videoStartTimecode;
      if (debug.enabled) {
        debug('[onChange()] prop: %s value: %s millis: %d', prop, value, millis);
      }
      onChange(prop, millis);
    }
  };
  autoCompleteOnchange = (data: string) => {
    this.onChange('label', data);
  };
  render() {
    const { index, onDeleteClick, startTimeInvalid, stopTimeInvalid, groupName, onSubmit } = this.props;
    let { label, startTimeMs, stopTimeMs } = this.state;
    const autoCompleteProp = {
      value: label,
      onChange: this.autoCompleteOnchange,
      metadataKeyName: groupName,
      itemsLength: 1,
      fromComponent: 'TimeDataPoint',
      onParentEnterClick: onSubmit
    };
    return (
      <div name="TimelineDatapointForm">
        <header>
          <span>{index ? `${index}. ${t('TIMELINE_DATAPOINT')}` : null}</span>
          {onDeleteClick && index > 1 ? (
            <Button icon={ThemeSetup.getImageURL('trash_red.svg')} onClick={onDeleteClick} />
          ) : null}
        </header>
        <div className="form block flex-row">
          <div className="form-field datapoint-label">
            <label>{t('DATAPOINT_LABEL')}</label>
            {<AutoCompleteComponent {...autoCompleteProp} />}
            {/* <input
              type="text"
              value={label}
              onChange={(e) => this.onChange('label', e.target.value)}
              onBlur={(e) => this.onBlur('label', e.target.value)}
            /> */}
          </div>
          <div className="form-field datapoint-start">
            <label>{t('DATAPOINT_START')}</label>
            <input
              type="text"
              className={classNames({ invalid: startTimeInvalid })}
              value={startTimeMs}
              onChange={(e) => this.onChange('startTimeMs', e.target.value)}
              onBlur={() => this.onBlur('startTimeMs', startTimeMs)}
            />
          </div>
          <div className="form-field datapoint-stop">
            <label>{t('DATAPOINT_STOP')}</label>
            <input
              type="text"
              className={classNames({ invalid: stopTimeInvalid })}
              value={stopTimeMs}
              onChange={(e) => this.onChange('stopTimeMs', e.target.value)}
              onBlur={() => this.onBlur('stopTimeMs', stopTimeMs)}
            />
          </div>
        </div>
      </div>
    );
  }
}
